import { useQuery } from '@tanstack/react-query';
import { GetPromotionRepliesQuery } from '@diritto/common/api/PromotionReplyApi';
import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';

import { PromotionReplyApi } from 'api/ApiHelper';
import { promotionsQueryKey } from 'queries/promotions/queryKey';

export const useGetPromotionRepliesQuery = (query: GetPromotionRepliesQuery & BasePaginatorDto, enabled = false) =>
  useQuery({
    queryKey: promotionsQueryKey.promotionRepliesList(query),
    queryFn: () =>
      PromotionReplyApi.getPromotionReplies({
        ...query,
      }),
    enabled,
  });
